export const SPEC_EDIT_REPORT = {
  headline: '“Pricing v2” spec — 3 sections changed',
  status: 'done',
  durationSec: 29,
  body: `**The “Pricing v2” spec was edited by Arjun** — 3 sections changed.

- **Plans:** the Team plan seat minimum drops from 5 to 3.
- **Usage limits:** agent runs per seat rise from 500 to 800 a month.
- **Open questions:** “Annual-only for Enterprise?” was resolved — monthly billing is allowed at a 15% premium.

Posted to #product with a link to the page.`,
}
